var cibGitlab = ["32 32", "<path d='M31.937 18.115l-1.787-5.511-3.552-10.921c-0.183-0.563-0.973-0.563-1.156 0l-3.552 10.916h-11.781l-3.552-10.916c-0.183-0.563-0.979-0.563-1.156 0l-3.552 10.916-1.792 5.516c-0.161 0.5 0.021 1.052 0.443 1.364l15.5 11.261 15.5-11.261c0.421-0.312 0.604-0.859 0.437-1.364z'/>"];

export { cibGitlab };

